import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import GeoLocationInput from "@/components/GeoLocationInput";

const COPERTURE_AUTO = [
  "RCA (obbligatoria)", "Furto e Incendio", "Kasko", "Cristalli", "Eventi atmosferici",
  "Assistenza stradale", "Tutela legale", "Infortuni conducente"
];

export function AutoStep0({ formData, update }) {
  return (
    <div className="space-y-5">
      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Tipo veicolo</Label>
        <Select value={formData.tipo_veicolo || ""} onValueChange={v => update("tipo_veicolo", v)}>
          <SelectTrigger className="rounded-xl border-[#E5E2DB] h-11" data-testid="tipo-veicolo-select"><SelectValue placeholder="Seleziona tipo veicolo" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="autovettura">Autovettura</SelectItem>
            <SelectItem value="moto">Moto</SelectItem>
            <SelectItem value="autocarro">Autocarro</SelectItem>
            <SelectItem value="ciclomotore">Ciclomotore</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label className="text-sm text-[#0F1F14]">Targa</Label>
        <Input value={formData.targa || ""} onChange={e => update("targa", e.target.value.toUpperCase())} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="AB123CD" data-testid="targa-input" />
      </div>
    </div>
  );
}

export function AutoStep1({ formData, update }) {
  return (
    <div className="space-y-5">
      <div className="space-y-3">
        <Label className="text-sm text-[#0F1F14] font-medium">Tipo assicurato</Label>
        <div className="flex gap-3">
          <button type="button" onClick={() => update("tipo_assicurato", "privato")}
            className={`flex-1 py-3 px-6 rounded-xl text-sm font-medium transition-all border-2 ${
              (formData.tipo_assicurato || "privato") === "privato" ? "bg-[#163321] text-white border-[#163321]" : "bg-white text-[#0F1F14] border-[#E5E2DB] hover:border-[#163321]/40"
            }`} data-testid="tipo-assicurato-privato">Privato</button>
          <button type="button" onClick={() => update("tipo_assicurato", "azienda")}
            className={`flex-1 py-3 px-6 rounded-xl text-sm font-medium transition-all border-2 ${
              formData.tipo_assicurato === "azienda" ? "bg-[#163321] text-white border-[#163321]" : "bg-white text-[#0F1F14] border-[#E5E2DB] hover:border-[#163321]/40"
            }`} data-testid="tipo-assicurato-azienda">Azienda</button>
        </div>
      </div>
      {formData.tipo_assicurato === "azienda" ? (
        <>
          <div className="space-y-2">
            <Label className="text-sm text-[#0F1F14]">Ragione Sociale</Label>
            <Input value={formData.ragione_sociale || ""} onChange={e => update("ragione_sociale", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="Nome dell'azienda" data-testid="ragione-sociale-input" />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-[#0F1F14]">Partita IVA</Label>
            <Input value={formData.partita_iva || ""} onChange={e => update("partita_iva", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="01234567890" data-testid="partita-iva-input" />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-[#0F1F14]">Referente aziendale</Label>
            <Input value={formData.nome_conducente || ""} onChange={e => update("nome_conducente", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" placeholder="Nome e Cognome referente" data-testid="referente-input" />
          </div>
        </>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label className="text-sm text-[#0F1F14]">Nome assicurato</Label>
            <Input value={formData.nome_conducente || ""} onChange={e => update("nome_conducente", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" data-testid="nome-conducente-input" />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-[#0F1F14]">Cognome assicurato</Label>
            <Input value={formData.cognome_conducente || ""} onChange={e => update("cognome_conducente", e.target.value)} className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]" data-testid="cognome-conducente-input" />
          </div>
        </div>
      )}
      <GeoLocationInput label="Sede Legale o Residenza" value={formData.residenza} onChange={v => update("residenza", v)} testId="residenza" />
    </div>
  );
}

export function AutoStep2({ formData, toggleArray }) {
  return (
    <div className="space-y-5">
      <p className="text-sm text-[#4A5E51]">Seleziona le coperture di tuo interesse. Ti aiuteremo a scegliere quelle più adatte.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {COPERTURE_AUTO.map(c => (
          <label key={c} className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${(formData.coperture || []).includes(c) ? 'border-[#163321] bg-[#163321]/5' : 'border-[#E5E2DB] hover:bg-[#F5F4F0]'}`} data-testid={`copertura-${c.replace(/\s/g, '-').toLowerCase()}`}>
            <Checkbox checked={(formData.coperture || []).includes(c)} onCheckedChange={() => toggleArray("coperture", c)} className="data-[state=checked]:bg-[#163321]" />
            <span className="text-sm text-[#0F1F14]">{c}</span>
          </label>
        ))}
      </div>
    </div>
  );
}

export function renderAutoStep(step, formData, update, toggleArray) {
  if (step === 0) return <AutoStep0 formData={formData} update={update} />;
  if (step === 1) return <AutoStep1 formData={formData} update={update} />;
  if (step === 2) return <AutoStep2 formData={formData} toggleArray={toggleArray} />;
  return null;
}
